import axios from 'axios';
import { auth } from '../src/firebase';
import jwtDecode from 'jwt-decode';
import _ from 'lodash';
import { getTenantFromToken } from './config/common';

const generateInterceptors = AxiosInstance => {
  AxiosInstance.interceptors.request.use(
    async config => {
      const token = localStorage.getItem(`jwtToken`);

      if (token) {
        const jwtPayload = jwtDecode(token);
        config.headers['Authorization'] = `Bearer ${token}`;
        config.headers['x-enliv-tenant-id'] = jwtPayload?.firebase?.tenant; //'Enliv-Dev-cr017';
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  AxiosInstance.interceptors.response.use(
    response => response,
    async error => {
      const originalRequest = error?.config;
      if (error?.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const user = auth?.currentUser;
          if (user) {
            const token = await user.getIdToken(true);
            localStorage.setItem('jwtToken', token);
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return AxiosInstance(originalRequest);
          } else {
            // window.location.href = "/login";
          }
        } catch (err) {}
      }
      return Promise.reject(error);
    }
  );
};

let AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'X-API-Key': 'c91b7d71-7e3b-46c8-9f6a-1e4bd42b4ce5',
    'Content-type': 'application/json',
  },
});

AxiosInstance.interceptors.request.use(function (config) {
  let baseURL = process.env.REACT_APP_API_URL + config.url;
  AxiosInstance.defaults.url = baseURL;
  let token = localStorage.getItem('jwtToken');
  config.headers['Authorization'] = 'Bearer ' + token;
  return config;
});

let ehrAPIBaseService = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

generateInterceptors(ehrAPIBaseService);

const ehrAPIServiceClaim = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/claim/',
});

generateInterceptors(ehrAPIServiceClaim);

const ehrAPIService = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/fhir/',
});

generateInterceptors(ehrAPIService);

const LabOrderLogin = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL + `/elabs/chc/${getTenantFromToken()}/`,
});

generateInterceptors(LabOrderLogin);

export const ehrAPIServiceDelete = async (resourceType, resourceId) => {
  // const response = await ehrAPIBaseService.delete('fhir/deleteResource', {
  //   data: {
  //     resourceType: resourceType,
  //     resourceId: resourceId,
  //   },
  // });

  const response = await ehrAPIBaseService.delete(
    `fhir/deleteResource?resourceType=${resourceType}&resourceId=${resourceId}`
  );
  return response;
};

const ehrAPIServiceFDB = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/fdb/',
});

generateInterceptors(ehrAPIServiceFDB);

const ehrAPIServiceSSO = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/sso/',
});
generateInterceptors(ehrAPIServiceSSO);

export const ehrAPIServiceMeta2 = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/metadata/v1/download/',

  //baseURL: 'https://ehr-metadata-service-hifck5sj6a-uk.a.run.app/v1/download/',
});

generateInterceptors(ehrAPIServiceMeta2);

export const ehrAPIServiceConfig = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/metadata/v1/config/',

  //baseURL: 'https://ehr-metadata-service-hifck5sj6a-uk.a.run.app/v1/config/',
});

generateInterceptors(ehrAPIServiceConfig);

const ehrAPIServiceMeta = axios.create({
  //baseURL: 'https://graphql-engine-hifck5sj6a-uk.a.run.app/',
  baseURL: process.env.REACT_APP_API_URL + '/metadata/v1/',
});

generateInterceptors(ehrAPIServiceMeta);

const ehrAPIServiceMetaProviderNotificationCount = axios.create({
  baseURL: 'https://graphql-engine-hifck5sj6a-uk.a.run.app/',
});

generateInterceptors(ehrAPIServiceMetaProviderNotificationCount);

const ehrAPIServiceMetaFeeschedule = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/metadata/v1/',
});

generateInterceptors(ehrAPIServiceMetaFeeschedule);

const ehrAPIServiceFile = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/file/',
});

generateInterceptors(ehrAPIServiceFile);

export const singleFileDownloadUrlGenerator = ({
  filename,
  type = 'thumbnail',
} = {}) => {
  /**
   *
   * @param @type {string} takes value in the form of 'thumbnail' or 'full'
   * @param @filename {string} takes value '{id}/name'
   */

  if (!filename) return;

  const token = localStorage.getItem(`jwtToken`);

  let url = `/file/getSingleFileDownloadUrl/?fileName=${filename}`;
  if (token) {
    const jwtPayload = jwtDecode(token);
    let tenantId = jwtPayload?.firebase?.tenant; //'Enliv-Dev-cr017';
    url = `/file/${tenantId}/getSingleFileDownloadUrl/?fileName=${filename}`;
  }

  let baseUrl = process.env.REACT_APP_API_URL + url;

  if (type === 'thumbnail') {
    baseUrl += `.160x160_thumbnail.jpg`;
  } else {
    baseUrl += `.jpg`;
  }

  return baseUrl;
};

function isDicomUrl(url) {
  const pattern = /\.dcm$/;
  return pattern.test(url);
}

export const singleFileDownloadUrlGeneratorFromFhirUrl = ({
  type = 'thumbnail',
  fileNameUrl,
} = {}) => {
  if (!fileNameUrl) return;
  const spArr = fileNameUrl?.split('.');
  if (type === 'thumbnail') {
    // debugger;
    spArr?.splice(1, 0, '160x160_thumbnail');
    fileNameUrl = spArr?.join('.');
  }

  let url = `/file/getSingleFileDownloadUrl/?fileName=${fileNameUrl}#${Date.now()}`;
  const token = localStorage.getItem(`jwtToken`);
  if (token) {
    const jwtPayload = jwtDecode(token);
    let tenantId = jwtPayload?.firebase?.tenant; //'Enliv-Dev-cr017';
    url = `/file/${tenantId}/getSingleFileDownloadUrl/?fileName=${fileNameUrl}#${Date.now()}`;
  }

  let baseUrl = process.env.REACT_APP_API_URL + url;
  // debugger;
  return baseUrl;
};

const generateMetaInterceptors = AxiosInstance => {
  AxiosInstance.interceptors.request.use(
    async config => {
      const token = localStorage.getItem(`jwtToken`);
      if (token) {
        const jwtPayload = jwtDecode(token);
        config.headers['Authorization'] = `Bearer ${token}`;
        config.headers['x-enliv-tenant-id'] = jwtPayload?.firebase?.tenant;
        config.headers['x-hasura-role'] = `admin`;
        config.headers[
          'x-hasura-admin-secret'
        ] = `c042293c-7ae1-43c5-bda1-fc3519f5fac2`;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );
};

const HTTPMetadata = ({
  action = '',
  module = '',
  params = ``,
  payload = {},
} = {}) => {
  const token = localStorage.getItem(`jwtToken`);
  let jwtPayload = {};
  if (token) jwtPayload = jwtDecode(token);
  let MetaHTTPRequest = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });
  generateMetaInterceptors(MetaHTTPRequest);
  return MetaHTTPRequest?.[_.lowerCase(action)](
    `metadata/v1/${jwtPayload?.firebase?.tenant}/${module}${
      params ? '?' + params : ''
    }`,
    payload
  );
};

export const CREATE_DYNAMIC_FORM = async ({
  userId = ``,
  formKey = ``,
} = {}) => {
  let response = await HTTPMetadata({
    action: 'post',
    module: 'forms/formData/create',
    payload: {
      object: {
        slFormKey: formKey,
      },
    },
  });

  if (!response?.data?.insert_Production_SLFormData_one?.id)
    throw new Error(`Form Id not generated`);

  let assignUserParams = {
    sl_form_data_id: '',
    user_id: '',
    user_type: '',
  };
  assignUserParams.sl_form_data_id =
    response?.data?.insert_Production_SLFormData_one?.id;
  assignUserParams.user_id = userId;
  assignUserParams.user_type = 'Patient';

  response = await HTTPMetadata({
    action: 'post',
    module: 'forms/formData/assignUser',
    payload: assignUserParams,
  });

  if (!response?.data?.insert_Production_user_forms_one?.sl_form_data_id)
    throw new Error(`User Form Id not generated`);

  const formId = formKey;
  const formDataId =
    response?.data?.insert_Production_user_forms_one?.sl_form_data_id;

  return { formId, formDataId };
};

export default AxiosInstance;
export {
  ehrAPIServiceClaim,
  ehrAPIService,
  ehrAPIServiceSSO,
  ehrAPIServiceFDB,
  ehrAPIServiceMeta,
  ehrAPIServiceFile,
  ehrAPIBaseService,
  ehrAPIServiceMetaFeeschedule,
  ehrAPIServiceMetaProviderNotificationCount,
  LabOrderLogin,
};
